const NoData = () => {
  return (
    <div className=" flex min-h-[200px] w-full items-center justify-center">
      داده ای برای نمایش موجود نیست !!!
    </div>
  );
};
export default NoData;
